var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicyDetailWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M15.004 49.005V5.755c0-1.651 1.355-2.994 3.02-2.994h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H18.024c-1.665 0-3.02-1.343-3.02-2.995z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47.514V4.264c0-1.651 1.354-2.994 3.02-2.994h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H16.02c-1.666 0-3.02-1.343-3.02-2.995z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.294 47.861V3.921l-32.669-.002-.001 43.941 32.67.001z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78 8.712H17.356v3.833H34.78V8.712z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M44.363 14.462H17.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.78 26.136H17.356v3.834H34.78v-3.834z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M44.363 31.886H17.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M50.924 3.459l-.007 44.867a2.187 2.187 0 01-2.2 2.183H15.2c-1.211 0-2.2-.98-2.2-2.183V46.58l31.647.007c1.219 0 2.2-.98 2.2-2.19l.008-43.127h1.868c1.212 0 2.2.98 2.2 2.189z",
    fill: "#291475"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M59.599 5.464l-.713-.386-.712-.386a1.984 1.984 0 00-2.698.8l-3.965 7.32-.223.402-12.085 22.319-.012.14-.308 3.812-.235 2.954 2.34-1.805 3.026-2.337.11-.081 12.094-22.315.865-1.598L60.4 8.182a2.012 2.012 0 00-.801-2.718z",
    fill: "#291475"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.038 3.825l1.42.774a1.993 1.993 0 01.801 2.703L41.98 37.345l-.11.08-3.026 2.338-2.34 1.805.236-2.954.308-3.813.012-.14 16.28-30.043a1.998 1.998 0 012.7-.793z",
    fill: "#ED1B2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.023 10.752l-.865 1.597 4.917 2.676.866-1.597-4.918-2.677z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.038 3.825l1.419.774a1.993 1.993 0 01.802 2.703l-3.316 6.12-4.919-2.677 3.316-6.12a1.99 1.99 0 012.698-.8z",
    fill: "#ED1B2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.056 34.805l4.814 2.62-3.02 2.336-2.344 1.813.235-2.953.315-3.816z",
    fill: "#FFDF8C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.741 38.62l2.108 1.14-2.343 1.814.235-2.953z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M56.75 4.21l.713.387a1.993 1.993 0 01.802 2.702l-16.28 30.043-.11.081-3.026 2.338-2.34 1.804L56.752 4.211z",
    fill: "#ED1B2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M24.584 38.793l-.692-.256-2.115-.793.546-1.468a1.238 1.238 0 00-.72-1.594 1.235 1.235 0 00-1.591.73l-.547 1.467-5.572-2.09.546-1.466a1.239 1.239 0 00-.72-1.594 1.235 1.235 0 00-1.592.73l-.546 1.466-2.807-1.05a1.554 1.554 0 00-2.003.914L1.555 47.761c-.3.809.105 1.707.912 2.007l15.809 5.925c.807.3 1.703-.105 2.003-.914l4.44-11.893.775-2.079a1.563 1.563 0 00-.91-2.014z",
    fill: "#291475"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.654 38.967l-5.215 13.972a1.549 1.549 0 01-2.004.914L1.626 47.928a1.558 1.558 0 01-.911-2.007L5.93 31.949a1.549 1.549 0 012.004-.914l15.808 5.925c.807.3 1.212 1.198.912 2.007z",
    fill: "#D8D8D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.654 38.967l-.776 2.078-18.73-7.018.775-2.079a1.549 1.549 0 012.003-.913l15.81 5.924c.813.301 1.217 1.2.918 2.008z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M24.654 38.967l-5.215 13.972a1.549 1.549 0 01-2.004.913L1.626 47.928a1.558 1.558 0 01-.911-2.007l.396-1.06 15.125 5.662c.806.3 1.703-.105 2.003-.914l4.819-12.905.691.256c.8.3 1.205 1.198.905 2.007z",
    fill: "#291475"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.598 31.489l-.951 2.54a1.24 1.24 0 01-1.592.73 1.244 1.244 0 01-.727-1.595l.95-2.54a1.24 1.24 0 011.592-.73c.319.123.559.359.69.649.138.283.16.62.038.946z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M13.598 31.49l-.951 2.54a1.24 1.24 0 01-1.591.728l1.814-4.863c.319.123.559.358.69.648.138.283.16.62.038.946z",
    fill: "#291475"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.482 34.443l-.95 2.54a1.24 1.24 0 01-1.592.73 1.244 1.244 0 01-.728-1.595l.951-2.54a1.24 1.24 0 011.591-.73c.319.123.559.359.69.648.138.284.16.62.038.947z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M21.482 34.443l-.95 2.54a1.241 1.241 0 01-1.592.73l1.815-4.864c.318.122.558.358.689.648.138.283.161.62.038.946z",
    fill: "#291475"
  })));
}

export default SvgPolicyDetailWide;